import PropTypes from 'prop-types';

import React from 'react';

import events from '../../../lib/events.js';

import EditableTextField from '../forms/editableTextField.jsx';

class EditableList extends React.Component {
  static defaultProps = {
    items: [],
  };

  static displayName = 'EditableList';

  static propTypes = {
    dataKey: PropTypes.string.isRequired,
    defaultNewObject: PropTypes.object, // Object to pass into new this.props.type();
    editMode: PropTypes.bool.isRequired,
    filter: PropTypes.func, // Filters objects in list
    items: PropTypes.array,
    objectKey: PropTypes.string, // Optional property to set in new item
    onChange: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    type: PropTypes.func, // Optional class to create new instance of
  };

  state = {
    newItem: '',
    promptDelete: [],
  };

  componentDidMount() {
    this.listener = events.subscribe('water-testers.save-partials', this.addItem);
  }

  componentWillReceiveProps(newProps) {
    if (!newProps.editMode && this.props.editMode) {
      this.setState({
        promptDelete: [],
      });
    }
  }

  componentWillUnmount() {
    if (this.listener) {
      this.listener.remove();
    }
  }

  addItem = () => {
    if (this.canAddItem()) {
      let items = this.props.items;

      if (this.props.type && this.props.objectKey && this.props.defaultNewObject) {
        let newItem = new this.props.type(this.props.defaultNewObject);

        newItem[this.props.objectKey] = this.state.newItem;
        items.push(newItem);
      } else{
        items.push({name: this.state.newItem});
      }
      this.props.onChange({key: this.props.dataKey, value: items});
      this.setState({newItem: ''});
      this.refs.waterTesterInput.focus();
    }
  };

  canAddItem = () => {
    return this.state.newItem && this.state.newItem.trim();
  };

  editNewItem = (event) => {
    this.setState({newItem: event.target.value});
  };

  handleChange = (event) => {
    this.props.onChange({key: this.props.dataKey, value: event.target.value});
  };

  handleDelete = (id, name) => {
    return () => {
      this.props.onDelete(id, name);
      this.refs.waterTesterInput.focus();
    };
  };

  render() {
    let list = this.props.items;

    if (this.props.filter) {
      list = list.filter(this.props.filter);
    }

    let content = list.map(value =>{
      return <div key={value.id} className={'input-group ' + (this.props.editMode ? 'editable' : '')}>
        <EditableTextField key={value.id} dataKey={value.name} value={value.name} placeholder={this.props.placeholder}
          onChange={this.handleChange} editMode={this.props.editMode} />
        {this.props.editMode ?
          <span className='input-group-btn'>
            <button className='btn btn-default' onClick={this.handleDelete(value.id, value.name)}><i className='bl bl-trash' /></button>
          </span> :
          null}
      </div>;
    });

    if (this.props.editMode) {
      return <div className='form-group'>
        {content}
        <div key='new' className='input-group'>
          <input type='text'
            className='form-control'
            ref='waterTesterInput'
            value={this.state.newItem}
            placeholder={this.props.placeholder}
            onChange={this.editNewItem} />
          <span className='input-group-btn'>
            <button className='btn btn-default' disabled={!this.canAddItem()}
            onClick={this.addItem}><i className='bl bl-plus' />
            </button>
          </span>
        </div>
      </div>;
    }

    return <div>
      {content}
    </div>;
  }
}

export default EditableList;
